export default __webpack_public_path__ + "static/media/categorie_icons_Invite_Reminder.f769f898.svg";